import { createAction } from "@reduxjs/toolkit";

/**
 * Single UI event: reset Sparxs catalog filters (category, status, period) to defaults.
 * Handled via extraReducers on each statistics filter slice.
 */
export const clearSparxsCatalogFiltersToDefaults = createAction(
  "statistics/clearSparxsCatalogFiltersToDefaults",
);
